import {dataTestId} from '@hconnect/uikit'
import {HPButton, HPButtonProps} from '@hconnect/uikit/src/lib2'
import {ManageSearch} from '@mui/icons-material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useAnalyzeProductionPlan} from '../../hooks'

interface AnalyzeProductionPlanButtonProps {
  backgroundMode?: HPButtonProps['backgroundMode']
}

export const AnalyzeProductionPlanButton = ({backgroundMode}: AnalyzeProductionPlanButtonProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const {analyzeProductionPlan, isLoading: shouldDisableAnalyzeButton} = useAnalyzeProductionPlan()

  return (
    <HPButton
      startIcon={<ManageSearch />}
      backgroundMode={backgroundMode}
      color="secondary"
      disabled={shouldDisableAnalyzeButton}
      onClick={analyzeProductionPlan}
      {...dataTestId('analyze_production_plan_button')}
    >
      {t('optimizer.analyzeProductionPlan')}
    </HPButton>
  )
}
